<template>
    <div class="custom-text-field" ref="dropdownContainer">
        <input 
          type="tel"
          ref="phoneInput"
          v-mask="currentMask"
          :value="phoneNumber"
          @input="onInput"
          placeholder="Введите номер телефона"
          :class="{'is-focused': isFocused, 'is-filled': phoneNumber}"
          class="border-0"
          @focus="isFocused = true"
          @blur="isFocused = false"
        />
    </div>
</template>

<script>
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import { mask } from 'vue-the-mask';

export default {
  name: 'PhoneNumberInput',
  directives: {
    mask
  },
  props: {
    value: { 
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneNumber: this.value,
      isValid: true,
      currentMask: '',
      isFocused: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.phoneInput;

      this.iti = intlTelInput(input, {
        preferredCountries: ['kg', 'ru'],
        onlyCountries: ['kg', 'ru'],
        initialCountry: 'kg',
        dropdownContainer: this.$refs.dropdownContainer,
        countrySearch: false,
      });

      input.addEventListener('open:countrydropdown', this.adjustDropdownPosition);
      input.addEventListener('countrychange', this.updateMask);
      this.updateMask();
    });
  },
  methods: {
    onInput(event) {
      this.phoneNumber = event.target.value;
      this.$emit('input-change', this.phoneNumber);
      this.validatePhoneNumber();
    },
    adjustDropdownPosition() {
      if (window.innerWidth <= 600) {
        const dropdown = document.body.querySelector('.iti__country-list');

        if (dropdown) {
          const inputRect = this.$refs.phoneInput.getBoundingClientRect();

          dropdown.style.position = 'absolute';
          dropdown.style.top = `${inputRect.bottom + window.scrollY}px`;
          dropdown.style.left = `${inputRect.left + window.scrollX}px`;
          dropdown.style.width = `${inputRect.width}px`;
          dropdown.style.zIndex = '1000';
          dropdown.style.backgroundColor = '#fff';
          dropdown.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
          dropdown.style.borderRadius = '4px';
          dropdown.style.padding = '8px 0';
          dropdown.style.maxHeight = '50vh';
          dropdown.style.overflowY = 'auto';
        }
      }
    },
    updateMask() {
      const countryData = this.iti.getSelectedCountryData();
      const countryCode = countryData.iso2;

      const masks = {
        kg: '+996 #########',
        ru: '+7 ##########'
      };

      this.currentMask = masks[countryCode] || '';
      this.validatePhoneNumber();
    },
    validatePhoneNumber() {
      const value = this.phoneNumber;
      const countryCode = this.iti.getSelectedCountryData().iso2;
      let regex;

      if (countryCode === 'kg') {
        regex = /^\+996\s?\d{9}$/;
      } else if (countryCode === 'ru') {
        regex = /^\+7\s?\d{10}$/;
      }

      this.isValid = regex ? regex.test(value.replace(/\D/g, '')) : false;
    }
  },
  watch: {
    value(newVal) {
      this.phoneNumber = newVal;
    }
  },
  beforeUnmount() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
};
</script>

<style scoped>
.custom-text-field {
    position: relative;
    margin: 0 0 10px;
    font-family: "Roboto", sans-serif;
    box-sizing: border-box;
  }
  
  .custom-text-field input {
    display: block;
    width: 100% !important;
    padding: 16px 12px 16px 12px;
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    font-size: 16px;
    outline: none;
    background-color: #fff;
    box-sizing: border-box;
  }

@media (max-width: 600px) {
  .iti__country-list {
    position: fixed !important; 
    top: auto !important;
    bottom: 0 !important;
    width: 100% !important;
    left: 0 !important;
    z-index: 1000 !important;
    max-height: 50vh !important; 
    overflow-y: auto !important;
  }
}
</style>